import React from 'react';
import Image from 'next/image';
import { SwiperSlide } from 'swiper/react';
import AppProjektDetailsComponent from './AppProjektDetailsComponent';
import { useTranslations } from '../../locales/useTranslations';

const AppDevelopmentKundenprojekte = () => {
    const { t } = useTranslations();

    return (
        <section className="case-studies-area pt-100 pb-70">
            <div className="container">
                <div className="section-title text-left">
                    <span className="sub-title">{t('appDevelopment_projects_subtitle')}</span>
                    <h2>{t('appDevelopment_projects_title')}</h2>
                </div>
            </div>

            <div className="container">
                <div className="row">

                    <div className="col-lg-4 col-sm-12 appdev-projects__project-col">
                        <AppProjektDetailsComponent
                            headerTitle={t('appDevelopment_projects_courtConnect_title')}
                            headerSlag={t('appDevelopment_projects_courtConnect_subtitle')}
                            headerDescription={t('appDevelopment_projects_courtConnect_description')}
                            altGoogleStore={"Simplify Data - Court-Connect App"}
                            altAppStore={"Simplify Data - Court-Connect App"}
                            googleLink={"https://play.google.com/store/apps/details?id=com.court_connect.app"}
                            appleLink={"https://apps.apple.com/de/app/courtconnect/id6451052261"}
                            swiperItems={
                                <>
                                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((num) => (
                                        <SwiperSlide key={num}>
                                            <div className="appdev-projects__slide-image-wrapper">
                                                <Image 
                                                    src={`/images/app-development/courtconnect_${num}.webp`}
                                                    alt="Simplify Data Entwicklung - Court-Connect.de"
                                                    width={0}
                                                    height={0}
                                                    sizes="100vw"
                                                    className="appdev-projects__slide-image"
                                                />
                                            </div>
                                        </SwiperSlide>
                                    ))}
                                </>
                            }
                        />
                    </div>

                    <div className="col-lg-4 col-sm-12 appdev-projects__project-col">
                        <AppProjektDetailsComponent
                            headerTitle={t('appDevelopment_projects_petConnect_title')}
                            headerSlag={t('appDevelopment_projects_petConnect_subtitle')}
                            headerDescription={t('appDevelopment_projects_petConnect_description')}
                            altGoogleStore={"Simplify Data - PetConnect App"}
                            altAppStore={"Simplify Data - PetConnect App"}
                            googleLink={"https://play.google.com/store/apps/details?id=com.petconnect.petconnect"}
                            appleLink={"https://apps.apple.com/de/app/pet-connect/id6751464862"}
                            swiperItems={
                                <>
                                    {[1, 2, 3, 4].map((num) => (
                                        <SwiperSlide key={num}>
                                            <div className="appdev-projects__slide-image-wrapper">
                                                <Image 
                                                    src={`/images/app-development/petconnect_${num}.webp`}
                                                    alt="Simplify Data Entwicklung - PetConnect"
                                                    width={0}
                                                    height={0}
                                                    sizes="100vw"
                                                    className="appdev-projects__slide-image"
                                                />
                                            </div>
                                        </SwiperSlide>
                                    ))}
                                </>
                            }
                        />
                    </div>

                    <div className="col-lg-4 col-sm-12 appdev-projects__project-col">
                        <AppProjektDetailsComponent
                            headerTitle={t('appDevelopment_projects_kinderwunsch_title')}
                            headerSlag={t('appDevelopment_projects_kinderwunsch_subtitle')}
                            headerDescription={t('appDevelopment_projects_kinderwunsch_description')}
                            altGoogleStore={"Simplify Data - Kinderwunsch - Beratung to go App"}
                            altAppStore={"implify Data - Kinderwunsch - Beratung to go App"}
                            googleLink={"https://play.google.com/store/apps/details?id=com.simplifydata.kinderwunsch.kinderwunschberatungtogo"}
                            appleLink={"https://apps.apple.com/app/kinderwunsch-beratung-to-go/id6479752676"}
                            swiperItems={
                                <>
                                    {[1, 2].map((num) => (
                                        <SwiperSlide key={num}>
                                            <Image 
                                                src={`/images/app-development/kinderwunsch_${num}.webp`}
                                                alt="Simplify Data Entwicklung - Kinderwunsch - Beratung to go"
                                                width={0}
                                                height={0}
                                                sizes="100vw"
                                                className="appdev-projects__slide-image"
                                            />
                                        </SwiperSlide>
                                    ))}
                                </>
                            }
                        />
                    </div>

                </div>
            </div>
        </section>
    );
}

export default AppDevelopmentKundenprojekte;
